"use client";

import { c as _c } from "react/compiler-runtime";
import { Avatar } from "@opensea/next-ui-kit";
import { CenterAligned, FlexCenter, formatAddress, ModalBody, ModalFooter, ModalFooterButton, ModalHeader, ModalHeaderTitle, TextBody, useToasts } from "@opensea/ui-kit";
import { SwapHoriz } from "@opensea/ui-kit/icons";
import { useExternalAccount, useSiwe } from "@opensea/wallet";
import { isError } from "es-toolkit";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { withSuspense } from "@/components/suspense/WithSuspense";
import { AnimatedLogo } from "../../../../../../packages/wallet/src/components/AnimatedLogo";
import { LinkedAccountSwitcherItem } from "../../../navigation/top-nav/account-switcher/LinkedAccountSwitcherItem";
import { useRenderUsdBalance } from "../use-render-usd-balance";
import { MoveLinkedWalletModalContent } from "./MoveLinkedWalletModalContent";
import { useConnectedAccountProfile } from "./use-connect-account-profile";
import { useLinkWallet } from "./use-link-wallet";
const LinkWalletChangeDetectedModalContentInner = ({
  address,
  connector,
  isSwitchingAccounts,
  onLoggedIn,
  onLinked,
  setIsSwitchingAccounts
}) => {
  const t = useTranslations("LinkWalletChangeDetectedModalContent");
  const [isLinkedToAnothedAccount, setIsLinkedToAnotherAccount] = useState(false);
  const {
    showErrorMessage
  } = useToasts();
  const {
    connect
  } = useExternalAccount();
  const renderUsdBalance = useRenderUsdBalance();
  const {
    promptSiwe
  } = useSiwe();

  // Fetch profile info for the connected account
  const {
    profile
  } = useConnectedAccountProfile(address);
  if (isLinkedToAnothedAccount) {
    return <MoveLinkedWalletModalContent address={address} goBack={() => setIsLinkedToAnotherAccount(false)} onLinked={onLinked} />;
  }
  return <>
      <ModalHeader className="flex justify-center pt-7 pb-1">
        <CenterAligned className="gap-6">
          {/* Wallet icons with arrow */}
          <FlexCenter className="gap-4">
            {connector.type === "embedded" ?
          // For embedded wallet, only show the OpenSea logo
          <AnimatedLogo size={60} /> :
          // For other wallets, show both icons with swap arrow
          <>
                <CenterAligned className="h-16 w-16 rounded-full bg-white">
                  {connector.icon && <Avatar size={48} src={connector.icon} />}
                </CenterAligned>
                <SwapHoriz size={24} />
                <AnimatedLogo size={60} />
              </>}
          </FlexCenter>

          <ModalHeaderTitle>{t("title")}</ModalHeaderTitle>
        </CenterAligned>
      </ModalHeader>
      <ModalBody className="flex flex-col gap-6">
        <TextBody className="text-center" color="text-secondary">
          {t("description1", {
          address: formatAddress(address)
        })}
        </TextBody>

        {/* Connected account preview */}
        <div className="rounded-lg border border-border-1 bg-bg-primary">
          <LinkedAccountSwitcherItem address={address} avatarSize={32} description={renderUsdBalance(profile?.portfolioSummary?.estimatedTokenValue?.usd ?? undefined)} displayName={profile?.displayName} imageUrl={profile?.imageUrl || undefined} isLink={false} isPrimary={false} onClick={undefined} showActions={false} showCheck={false} showNotLinked variant="full" />
        </div>
      </ModalBody>
      <ModalFooter>
        <ModalFooterButton disabled={isSwitchingAccounts} isLoading={isSwitchingAccounts} onClick={async () => {
        try {
          setIsSwitchingAccounts(true);
          await connect();
          await promptSiwe();
          onLoggedIn();
        } catch (err) {
          showErrorMessage(isError(err) ? err.message : "Failed to log in");
        } finally {
          setIsSwitchingAccounts(false);
        }
      }} variant="secondary">
          {t("switchAccounts")}
        </ModalFooterButton>
        <LinkWalletButton address={address} onAlreadyLinked={() => setIsLinkedToAnotherAccount(true)} onLinked={onLinked} />
      </ModalFooter>
    </>;
};
const LinkWalletButton = t0 => {
  const $ = _c(10);
  const {
    address,
    onLinked,
    onAlreadyLinked
  } = t0;
  const t = useTranslations("LinkWalletChangeDetectedModalContent");
  let t1;
  if ($[0] !== address || $[1] !== onAlreadyLinked || $[2] !== onLinked) {
    t1 = {
      address,
      onLinked,
      onAlreadyLinked
    };
    $[0] = address;
    $[1] = onAlreadyLinked;
    $[2] = onLinked;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    linkWallet,
    isLinking
  } = useLinkWallet(t1);
  let t2;
  if ($[4] !== t) {
    t2 = t("linkWalletToAccount");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== isLinking || $[7] !== linkWallet || $[8] !== t2) {
    t3 = <ModalFooterButton autoFocus={true} disabled={isLinking} isLoading={isLinking} onClick={linkWallet} variant="primary">{t2}</ModalFooterButton>;
    $[6] = isLinking;
    $[7] = linkWallet;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export const LinkWalletChangeDetectedModalContent = withSuspense(LinkWalletChangeDetectedModalContentInner, {
  fallback: null
});